import React from 'react';

const collectionLinks = [
  {
    text: 'Wireless Fences',
    href: 'https://www.petsafe.com/shop/fencing/wireless-pet-fences/',
  },
  {
    text: 'In-Ground Fences',
    href: 'https://www.petsafe.com/shop/fencing/in-ground-pet-fences/',
  },
  {
    text: 'Litter Boxes',
    href: 'https://www.petsafe.com/shop/litter-boxes-and-litter/litter-boxes/',
  },
  {
    text: 'Bark Collars',
    href: 'https://www.petsafe.com/shop/training/bark-control/',
  },
  {
    text: 'Batteries',
    href: 'https://www.petsafe.com/shop/batteries-and-replacement-power-adaptors/',
  },
];

function StoreList() {
  return (
    <ul className="m-0 p-0 list-none">
      {collectionLinks.map(link => (
        <li key={link.text}>
          <a
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center text-white no-underline leading-8 hover:underline"
          >
            {link.text}
          </a>
        </li>
      ))}
    </ul>
  );
}

export default StoreList;
